import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "checklist/type-item"

class service {

    selectList(params) {
        return http.list(path + "/selectList",params);
    }

    getAllItems() {
        let params = new URLSearchParams()
        params.set("status", "1")
        return http.list(path + "/selectAllResponseList",params);
    }

    getAllItemsOrderName() {
        let params = new URLSearchParams()
        params.set("status", "1")
        params.set("sorted", "name")
        return http.list(path + "/selectAllResponseList",params);
    }


}

export default new service();

